<template>

  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <div class="container-flex">
        <div class="container-left">
          <img class="background-img" src="~@/assets/background.png" alt="">
        </div>
        <div class="user-layout-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'
import defaultSettings from '@/config/defaultSettings'
import { updateTheme } from '@ant-design-vue/pro-layout'

export default {
  name: 'UserLayout',
  components: {
  },
  mixins: [deviceMixin],
  data() {
    return {
      settings: {
        // 主色调
        primaryColor: defaultSettings.primaryColor
      }
    }
  },
  mounted() {
    document.body.classList.add('userLayout')
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style rel="stylesheet/less" lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 480px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 100%;
    background-color: #F8FAFB;
    display: flex;
    justify-content: center;
    align-items: center;
    .container-flex {
      background-color: #fff;
      border-radius: 30px;
      overflow: hidden;
      box-shadow: 0px 2px 10px 1px #EFF2FF;
      display: flex;
      justify-content: center;
      align-items: center;
      .container-left {
        .background-img {
          height: 480px;
        }
      }
    }

    .user-layout-content {
      background-color: #fff;
      height: 500px;
      padding: 10px;
      .main {
        min-width: 260px;
        width: 480px;
        margin: 0 auto;
      }

    }

    a {
      text-decoration: none;
    }

  }
}
</style>
